import { createFileRoute } from '@tanstack/react-router';
import { AdminDashboardPage } from '../../features/reporting';

export const Route = createFileRoute('/admin/dashboard')({ component: AdminDashboardPage });
